export const pl = {
    common: {
        loading: 'Ładowanie...',
        error: 'Coś poszło nie tak',
        save: 'Zapisz',
        cancel: 'Anuluj',
        delete: 'Usuń',
        download: 'Pobierz',
        upload: 'Wgraj',
        back: 'Wstecz',
        noResults: 'Brak wyników',
    },
    nav: {
        dashboard: 'Panel',
        projects: 'Projekty',
        settings: 'Ustawienia',
        admin: 'Admin',
        clients: 'Klienci',
        leads: 'Leady',
        files: 'Pliki',
        logout: 'Wyloguj',
    },
    dashboard: {
        title: 'Panel',
        welcome: 'Witaj, {name}',
        yourProjects: 'Twoje projekty',
        noProjects: 'Brak projektów. Twój konsultant przygotuje Twój obszar roboczy.',
        diagnosticBanner: 'Ukończyłeś diagnostykę AI Production Readiness dnia {date}.',
        viewResults: 'Zobacz wyniki',
    },
    projects: {
        title: 'Projekty',
        deliverables: 'Materiały',
        noDeliverables: 'Nie wgrano jeszcze żadnych materiałów.',
        uploaded: 'Wgrano {date}',
        version: 'w{version}',
    },
    access: {
        title: 'Poproś o dostęp',
        subtitle: 'Twój email jest zweryfikowany, ale nie masz jeszcze konta w portalu.',
        name: 'Twoje imię',
        company: 'Firma',
        interest: 'W czym możemy pomóc? (opcjonalne)',
        submit: 'Poproś o dostęp',
        submitted: 'Zgłoszenie wysłane. Odezwiemy się wkrótce.',
    },
    admin: {
        clients: 'Klienci',
        newOrg: 'Nowa organizacja',
        inviteUser: 'Zaproś użytkownika',
        leads: 'Leady diagnostyczne',
        uploadFile: 'Wgraj plik',
        newProject: 'Nowy projekt',
    },
    gdpr: {
        exportData: 'Eksportuj moje dane',
        deleteAccount: 'Usuń moje konto',
        deleteConfirm: 'Ta akcja jest nieodwracalna. Twoje konto zostanie natychmiast dezaktywowane, a dane trwale usunięte w ciągu 30 dni.',
    },
    scanner: {
        campaigns: 'Kampanie',
        newCampaign: 'Nowa kampania',
        campaignName: 'Nazwa kampanii',
        campaignNamePl: 'Nazwa kampanii (po polsku)',
        organisation: 'Organizacja',
        deadline: 'Termin ankiety',
        inviteMessage: 'Treść zaproszenia e-mail',
        status: 'Status',
        responses: 'Odpowiedzi',
        invites: 'Zaproszenia',
        tools: 'Wykryte narzędzia',
        draft: 'Szkic',
        active: 'Aktywna',
        closed: 'Zamknięta',
        archived: 'Archiwalna',
        sendInvites: 'Wyślij zaproszenia',
        addEmails: 'Dodaj adresy e-mail (jeden na linię)',
        analyse: 'Analizuj odpowiedzi',
        downloadReport: 'Pobierz raport',
        riskLevel: 'Poziom ryzyka',
        dataSensitivity: 'Wrażliwość danych',
        businessCriticality: 'Krytyczność biznesowa',
        department: 'Dział',
        useCase: 'Zastosowanie',
        noResponses: 'Brak odpowiedzi. Wyślij zaproszenia, aby rozpocząć zbieranie danych.',
        noCampaigns: 'Brak kampanii. Utwórz nową, aby rozpocząć skanowanie.',
        activate: 'Aktywuj kampanię',
        closeCampaign: 'Zamknij kampanię',
        template: 'Szablon ankiety',
        surveyTitle: 'Ankieta — narzędzia AI w pracy',
        surveySubtitle: 'Ta ankieta jest anonimowa i zajmuje ok. 3 minuty.',
        surveySubmitted: 'Dziękujemy! Twoja odpowiedź została zapisana.',
        surveyExpired: 'Ta ankieta została zamknięta.',
        next: 'Dalej',
        submit: 'Wyślij',
        previous: 'Wstecz',
    },
};
